import React, { useEffect } from 'react'

import { Helmet} from 'react-helmet'

export default function Metatag(props) {
 
    const titlehtml =  props.title
    const keywords = props.keywords
    const description = props.description
    const errorPage = props.error

  return (
    <>
    {/* {/ implementation for head tag  /} */}
        <Helmet>
            {
                titlehtml != null && titlehtml != ''  ?
                    <title>{titlehtml}</title>
                :
                null
            }
            {
                keywords != null && keywords != '' ?
                    <meta name='keywords' content={keywords} data-react-helmet="true"/>

                :
                null
            }
            {
                description != null && description != ''  ? 
                    <meta name='description' content={description} data-react-helmet="true"/>
                :
                null

            }
            
            <meta property="og:title" content={titlehtml != null && titlehtml != ''  ? titlehtml : "National Disease Modelling Consortium | Disease Modelling in India | Disease Modellers in India"}/>
            <meta property="og:description" content={description != null && description != ''  ? description : "NDMC aims to generate consolidated estimates of disease occurrence and the overall effect of vaccination in the population."}/>
            <meta property="og:image" content="https://ndmcreact-website.azurewebsites.net/images/logo.png"/>
            {
            errorPage === "1" ?
            <meta name="robots" content="noindex, follow"/>
            :
            null
          }
            
        </Helmet>
    </>
  )
}
